import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/serah-terima-operasi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/serah-terima-operasi/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/serah-terima-operasi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/serah-terima-operasi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function prefill(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/serah-terima-operasi/prefill`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPraPenyerah(id: number, data) {
  const response = await http.putData(`/serah-terima-operasi/${id}/sign-pra-penyerah`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPraPenerima(id: number, data) {
  const response = await http.putData(`/serah-terima-operasi/${id}/sign-pra-penerima`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPascaPenyerah(id: number, data) {
  const response = await http.putData(`/serah-terima-operasi/${id}/sign-pasca-penyerah`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPascaPenerima(id: number, data) {
  const response = await http.putData(`/serah-terima-operasi/${id}/sign-pasca-penerima`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/serah-terima-operasi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/serah-terima-operasi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  prefill,
  signPraPenyerah,
  signPraPenerima,
  signPascaPenyerah,
  signPascaPenerima,
  destroy,
  print
};
